import { InjectionToken } from '@angular/core';

import { BaasConfirmSettings } from './baas-confirm.types';

export const BAAS_CONFIRM_SETTINGS = new InjectionToken<BaasConfirmSettings>('BaaS confirm service settings');
